import { DataTable } from "@/core/components/layout/data-table";
import { Card, CardContent } from "@/core/components/ui/card";
import { Input } from "@/core/components/ui/input";
import { DashboardFilters } from "@/dashboard/types";
import { Search } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDashboardRankingsUsersSheet } from "../../hooks/use-dashboard-rankings-users-sheet";
import { Top3Ranking } from "../top-3-ranking";

interface DashboardRankingsUsersDataTableSheetProps extends React.ComponentPropsWithoutRef<"div"> {
  filters: DashboardFilters;
}

export const DashboardRankingsUsersDataTableSheet = ({
  filters,
  ...props
}: DashboardRankingsUsersDataTableSheetProps) => {
  const [translate] = useTranslation(["dashboard"]);
  const {
    table,
    isLoading,
    searchParams,
    top3RankingData: top3RankingDataSheet,
  } = useDashboardRankingsUsersSheet(filters);
  const [top3RankingData, setTop3RankingData] = useState<
    { position: number; name: string; value: number }[]
  >([]);

  useEffect(() => {
    if (!table.getState().globalFilter && searchParams.page === 1) {
      setTop3RankingData(top3RankingDataSheet);
    }
  }, [top3RankingDataSheet, searchParams.page]);

  return (
    <div {...props} className="flex flex-col gap-4">
      <div className="relative flex-1">
        <Search className="absolute left-2 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
        <Input
          type="search"
          placeholder={
            translate("dashboard-rankings-users-search-placeholder") as string
          }
          className="pl-8"
          value={(table.getState().globalFilter as string) ?? ""}
          onChange={(e) => table.setGlobalFilter(e.target.value)}
        />
      </div>

      <Top3Ranking data={top3RankingData} isLoading={isLoading} />

      <Card className="border-none">
        <CardContent className="p-4 pt-0">
          <DataTable table={table} isLoading={isLoading} />
        </CardContent>
      </Card>
    </div>
  );
};
